// extracted by mini-css-extract-plugin
export var copyableItem = "_e-0";
export var underlined = "_e-1";